import client from './index'
import store from '@/store'
const myIdentity = () => client['api'].get(`user`)
const activesemester = () => client['api'].get(`activesemester`)
const reqCurrentSemester = () => client['api'].get(`current-semester`)
const login = (data) => client['api'].post(`login`, data)
const changeAccount = (data) => client['api'].post(`changeAccount`, {data})
const updateProfile = (data) => client['api'].post(`updateProfile`, data)
const changePassword = (data) => client['api'].post(`user/changepassword`, data)
const logoutUser = (data) => client['api'].post(`logout`, data)
const profilePicture = (data) => client['api'].post(`profilePicture`, data, {"Content-Type": "multipart/form-data",  onUploadProgress: progressEvent => {
    let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
    store.dispatch('setLoading',percentCompleted)
}})
export {
    login,
    changePassword,
    myIdentity,
    updateProfile,
    profilePicture,
    logoutUser,
    activesemester,
    changeAccount,
    reqCurrentSemester
}